import { ChartDataComparisonType } from '../data/ChartDataComparisonType';
import { ChartDataType } from '../data/ChartDataType';

export class LegendData {
  constructor(
    public label: string | null,
    public className: string,
    public color?: string,
    public dataType?: ChartDataType,
    public comparisonType?: ChartDataComparisonType,
    public iconType: 'line' | 'dot' = 'line'
  ) {}
}
